import React from 'react';
import { Modal } from 'react-bootstrap';

import styles from './ConfirmSubmitModal.css';

export default class ConfirmSubmitModal extends React.Component {
  render() {
    const { showConfirmSubmitModal, confirmCreateButtonStatus } = this.props;

    return (
      <Modal
        show={showConfirmSubmitModal}
        dialogClassName={styles['modal-dialog']}
      >
        <Modal.Header bsClass={`modal-header ${styles['modal-header']}`}>
          Information
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to proceed? You cannot edit or delete this entry
          after saving.
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            onClick={this._onHide}
            className="btn btn-default"
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={this._onClickCreate}
            disabled={confirmCreateButtonStatus}
          >
            OK
          </button>
        </Modal.Footer>
      </Modal>
    );
  }

  _onClickCreate = () => {
    this.props.onConfirmCreateTransfer();
  };

  _onHide = () => {
    this.props.setShowConfirmSubmitModal(false);
  };
}
